export default class extends HTMLElement {
  connectedCallback () {
    this.display = this.querySelector('[data-note-display]')
    this.form = this.querySelector('[data-note-form]')
    this.input = this.querySelector('[data-note-input]')
    this.editBtn = this.querySelector('[data-note-edit]')
    this.cancelBtn = this.querySelector('[data-note-cancel]')
    this.savedValue = this.input?.value || ''

    this.editBtn?.addEventListener('click', (event) => this.startEdit(event))
    this.cancelBtn?.addEventListener('click', (event) => this.cancelEdit(event))
    this.form?.addEventListener('submit', (event) => this.save(event))
    this.input?.addEventListener('keydown', (event) => this.handleKeydown(event))

    this.addEventListener('click', (event) => event.stopPropagation())
  }

  startEdit (event) {
    event.preventDefault()
    event.stopPropagation()

    this.savedValue = this.input.value
    this.display.classList.add('hidden')
    this.form.classList.remove('hidden')
    this.input.focus()
    this.input.select()
  }

  cancelEdit (event) {
    event?.preventDefault()
    event?.stopPropagation()

    this.input.value = this.savedValue
    this.form.classList.add('hidden')
    this.display.classList.remove('hidden')
  }

  handleKeydown (event) {
    if (event.key === 'Escape') {
      event.preventDefault()
      this.cancelEdit()
    }
  }

  async save (event) {
    event.preventDefault()
    event.stopPropagation()

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const value = this.input.value.trim()

    this.form.classList.add('opacity-60', 'pointer-events-none')

    try {
      const response = await fetch(this.dataset.url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/vnd.turbo-stream.html, text/html',
          'X-CSRF-Token': token
        },
        body: JSON.stringify({ submission: { name: value } })
      })

      if (!response.ok) throw new Error('save_failed')

      const html = await response.text()

      if (html.includes('turbo-stream')) {
        window.Turbo?.renderStreamMessage(html)
      } else {
        window.location.reload()
      }
    } catch (_error) {
      this.form.classList.remove('opacity-60', 'pointer-events-none')
    }
  }
}
